import { Link } from 'react-router-dom';
import type { Work } from '@/types';

interface WorkCardProps {
  work: Work;
  rank?: number;
}

export default function WorkCard({ work, rank }: WorkCardProps) {
  const typeLabel = work.type === 'movie' ? '电影' : '电视剧';

  return (
    <Link
      to={`/detail/${work.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden bg-background-900" style={{ aspectRatio: '2 / 3' }}>
        <img
          src={work.cover}
          alt={work.title}
          title={`${work.title} 影视海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-2 top-2 rounded-md bg-foreground-950/75 px-2 py-0.5 text-xs font-semibold text-accent-300">
          {work.rating.toFixed(1)}
        </span>
        {typeof rank === 'number' && (
          <span className="absolute left-0 top-0 flex h-7 w-7 items-center justify-center rounded-br-lg bg-accent-500 text-sm font-bold text-background-50">
            {rank}
          </span>
        )}
        <span className="absolute bottom-2 left-2 rounded-md bg-primary-900/80 px-2 py-0.5 text-xs text-background-50">
          {typeLabel}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 md:text-base" title={work.title}>
          {work.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-600">
          {work.year} · {work.region}
        </p>
        <div className="mt-2 flex flex-wrap gap-1">
          {work.genres.slice(0, 2).map((g) => (
            <span key={g} className="rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-900">
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}